import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './activity-time-availability.reducer';

export const ActivityTimeAvailabilityDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const activityTimeAvailabilityEntity = useAppSelector(state => state.activityTimeAvailability.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="activityTimeAvailabilityDetailsHeading">
          <Translate contentKey="activitiesApp.activityTimeAvailability.detail.title">ActivityTimeAvailability</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{activityTimeAvailabilityEntity.id}</dd>
          <dt>
            <span id="fromDate">
              <Translate contentKey="activitiesApp.activityTimeAvailability.fromDate">From Date</Translate>
            </span>
          </dt>
          <dd>
            {activityTimeAvailabilityEntity.fromDate ? (
              <TextFormat value={activityTimeAvailabilityEntity.fromDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="toDate">
              <Translate contentKey="activitiesApp.activityTimeAvailability.toDate">To Date</Translate>
            </span>
          </dt>
          <dd>
            {activityTimeAvailabilityEntity.toDate ? (
              <TextFormat value={activityTimeAvailabilityEntity.toDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="hour">
              <Translate contentKey="activitiesApp.activityTimeAvailability.hour">Hour</Translate>
            </span>
          </dt>
          <dd>{activityTimeAvailabilityEntity.hour}</dd>
          <dt>
            <span id="minute">
              <Translate contentKey="activitiesApp.activityTimeAvailability.minute">Minute</Translate>
            </span>
          </dt>
          <dd>{activityTimeAvailabilityEntity.minute}</dd>
          <dt>
            <span id="ampm">
              <Translate contentKey="activitiesApp.activityTimeAvailability.ampm">Ampm</Translate>
            </span>
          </dt>
          <dd>{activityTimeAvailabilityEntity.ampm}</dd>
          <dt>
            <span id="adultCount">
              <Translate contentKey="activitiesApp.activityTimeAvailability.adultCount">Adult Count</Translate>
            </span>
          </dt>
          <dd>{activityTimeAvailabilityEntity.adultCount}</dd>
          <dt>
            <span id="childCount">
              <Translate contentKey="activitiesApp.activityTimeAvailability.childCount">Child Count</Translate>
            </span>
          </dt>
          <dd>{activityTimeAvailabilityEntity.childCount}</dd>
          <dt>
            <span id="infantCount">
              <Translate contentKey="activitiesApp.activityTimeAvailability.infantCount">Infant Count</Translate>
            </span>
          </dt>
          <dd>{activityTimeAvailabilityEntity.infantCount}</dd>
          <dt>
            <span id="userName">
              <Translate contentKey="activitiesApp.activityTimeAvailability.userName">User Name</Translate>
            </span>
          </dt>
          <dd>{activityTimeAvailabilityEntity.userName}</dd>
          <dt>
            <Translate contentKey="activitiesApp.activityTimeAvailability.activityAvailability">Activity Availability</Translate>
          </dt>
          <dd>{activityTimeAvailabilityEntity.activityAvailability ? activityTimeAvailabilityEntity.activityAvailability.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/activity-time-availability" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/activity-time-availability/${activityTimeAvailabilityEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ActivityTimeAvailabilityDetail;
